import ConsentMatrixConfigView from "../presentation/views/ConsentMatrixConfigView.vue";
export const consentRoutes = [
    {
        path: "/module/consent-matrix",
        name: "ConsentMatrixConfig",
        component: ConsentMatrixConfigView,
        // Module-configuration surfaces are admin-only, consistently with
        // /module/communication-providers (OP-6888). The router guard redirects to /error/403;
        // OPINK independently refuses with its own 403.
        meta: {
            requiresAuth: true,
            requiresCapability: "opink.admin",
            titleKey: "consent.matrix.title",
        },
    },
    {
        path: "/module/consent-purposes",
        name: "ConsentPurposeCatalogue",
        component: () => import("../presentation/views/ConsentPurposeCatalogueView.vue"),
        meta: {
            requiresAuth: true,
            requiresCapability: "opink.admin",
            titleKey: "consentPurposeCatalogue.title",
        },
    },
];
export const consentNavigationItems = [
    {
        labelKey: "module.title",
        children: [
            {
                labelKey: "consent.matrix.title",
                path: "/module/consent-matrix",
                meta: { requiresAuth: true },
            },
            {
                labelKey: "consentPurposeCatalogue.title",
                path: "/module/consent-purposes",
                meta: { requiresAuth: true },
            },
        ],
    },
];
